module.exports = __webpack_public_path__ + "static/media/top-section.fe873b08.png";